import { useContext } from 'react';

import GlobalViewModeContext, { GlobalViewModeValues } from './context';

const useGlobalViewMode = (): GlobalViewModeValues => useContext(GlobalViewModeContext);

export default useGlobalViewMode;
